const Socket = {
  initialize() {
    if (window.appReactSocket) return window.appReactSocket;
    Socket.connected = false;
    Socket.connectionAttempts = 0;
    Socket.waitingOn = {};
    Socket.callbacks = {};
    Socket.connect();
    window.appReactSocket = Socket;
    return window.appReactSocket;
  },

  teardown() {
    Socket.ws.close();
    if (Socket.heartbeat) clearInterval(Socket.heartbeat);
    delete Socket.connected;
    delete Socket.connectionAttempts;
    delete Socket.host;
    delete Socket.token;
    delete Socket.waitingOn;
  },

  connect() {
    if (Socket.connecting) return;
    Socket.connecting = true;
    Socket.debug('Connecting...');
    Socket.ws = new WebSocket(`wss://${window.location.host}/admin_live_data`);
    Socket.ws.onopen = Socket.onOpen;
    Socket.ws.onmessage = Socket.onMessage;
    Socket.ws.onclose = Socket.onClose;
    Socket.ws.onerror = Socket.onClose;
  },

  register(key, callback) {
    Socket.callbacks[key] = callback;
  },

  sendHeartbeat() {
    if (Socket.connected) {
      try {
        Socket.ws.send('ping');
      } catch (error) {
        Socket.ws.close?.();
      }
    }
  },

  onClose() {
    if (Socket.connected) {
      Socket.connected = false;
      Socket.connecting = false;
      // Socket.debug('connection closed', code)
      clearInterval(Socket.heartbeat);
      clearTimeout(Socket.resetConnectionAttempts);
    }
  },

  onMessage(msg) {
    const parsed = JSON.parse(msg.data);
    if (Socket.callbacks[parsed.description]) Socket.callbacks[parsed.description](parsed.data);
    if (parsed.ack) Socket.waitingOn[parsed.ack]?.();
    if (parsed.sync) {
      Socket.debug('Sync message:', parsed);
      Socket.messageListener?.(parsed.sync);
    }
  },

  debug(...args) {
    console.log('SOCKET', ...args);
  },

  onOpen() {
    Socket.connected = true;
    Socket.connecting = false;
    Socket.resetConnectionAttempts = setTimeout(() => (Socket.connectionAttempts = 0), 60000);
    Socket.heartbeat = setInterval(Socket.sendHeartbeat, 30000);
    Socket.connectionListener?.();
  }
};

module.exports = Socket;
